import React from "react";

import { ButtonGroup, AnchorButton } from "@blueprintjs/core";

export default function Page() {
  return (
    <>
      <h1>Pocket Secure New</h1>
      <p>New pocket secure demo web client.</p>
      <ButtonGroup large vertical>
        <AnchorButton href="/web/apidocs" rightIcon="function">
          View API documentation
        </AnchorButton>
        <AnchorButton href="/web/register" rightIcon="new-person">
          Register A New Account
        </AnchorButton>
        <AnchorButton href="/web/login" rightIcon="log-in">
          Log Into an existing account
        </AnchorButton>
      </ButtonGroup>
    </>
  );
}
